import React from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames';

class Placeholder extends React.Component {
  render() {
    const { admin, components, placeholderId, plugins } = this.props;

    const pluginElements = [];

    const createReactComponent = plugin => {
      if (!components[plugin.pluginType]) {
        throw new Error(
          `Plugin ${plugin.pluginType} is not defined in the componentMap`
        );
      }

      return React.createElement(
        components[plugin.pluginType],
        Object.assign({}, JSON.parse(plugin.props), {
          key: plugin.id,
          pluginId: plugin.id,
          cmsAdmin: this.props.admin,
          children:
            plugin.children && plugin.children.map(p => createReactComponent(p))
        })
      );
    };

    for (let plugin of plugins) {
      pluginElements.push(createReactComponent(plugin));
    }

    const outputClasses = [];
    // Apply CMS markup if we're in the admin.
    // Don't include .cms-placeholder because it defaults to `overflow: hidden`
    // which hides the React-rendered content.
    if (admin && placeholderId) {
      outputClasses.push(`cms-placeholder-${placeholderId}`);
    }

    return <div className={classNames(outputClasses)}>{pluginElements}</div>;
  }
}

Placeholder.propTypes = {
  slot: PropTypes.string.isRequired,
  placeholderId: PropTypes.number,
  plugins: PropTypes.arrayOf(PropTypes.object).isRequired,
  admin: PropTypes.bool
};

Placeholder.defaultProps = {
  placeholderId: null
};

export default Placeholder;
